// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "service_resource_requirement".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "service_resource_requirement" table (1:1 with a DB row, on the wire). */
export const serviceResourceRequirementAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    serviceId: z.string(),
    categoryId: z.string(),
    quantity: z.number(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=serviceResourceRequirement.js.map